import { DateTime } from 'luxon';

export const formatDateTime = (date: string | undefined | null) => {
  if (!date) {
    return '';
  }
  // Parse and display in UTC without timezone conversion
  // The localTime from backend is already in the correct timezone, marked as UTC
  const dateLuxon = DateTime.fromISO(date, { zone: 'utc' });
  const formattedDateTime = dateLuxon.toFormat('dd.MM.yyyy HH:mm:ss');
  return formattedDateTime;
};

export const formatDateTimeInZone = (
  date: string | undefined | null,
  timeZone: string | undefined | null
) => {
  if (!date) {
    return '';
  }
  // Metadata timestamps come from backend in UTC (unlike localTime, which the
  // gateway already converts). Convert them to the point's local timezone
  // (installationTimezone, e.g. 'Europe/Prague') so they match the times shown
  // on MW. Falls back to UTC display when the zone is missing or invalid.
  const dateLuxon = DateTime.fromISO(date, { zone: 'utc' });
  const zoned = timeZone ? dateLuxon.setZone(timeZone) : dateLuxon;
  if (!zoned.isValid) {
    return formatDateTime(date);
  }
  return zoned.toFormat('dd.MM.yyyy HH:mm:ss');
};

export const formatDateTimeToIso = (date: string | undefined | null) => {
  if (!date) {
    return null;
  }
  const dateLuxon = DateTime.fromISO(date);
  const isoDateTime = dateLuxon.toISO();
  return isoDateTime;
};

export const formatStringToAmountDecimal = (amount: string) => {
  if (!/^\d+$/.test(amount)) {
    return amount;
  }

  return (Number(amount) / 100).toFixed(2);
};

export const formatToLocalInput = (date: Date) => {
  const tzOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - tzOffset).toISOString().slice(0, 16);
};
